import { isString } from "lodash";
import { translateBackendError } from "./translateBackendError";

const toastError = (err, toastInstance) => {
  try {
    const safeToast = toastInstance;
    const responseError = err?.response?.data?.error;

    // ✅ FIX: Suporta erro como string OU como objeto { code, message }
    let backendError = null;
    if (isString(responseError)) {
      backendError = responseError;
    } else if (responseError?.code) {
      backendError = responseError.code;
    } else if (responseError?.message) {
      backendError = responseError.message;
    }

    const message = backendError || (isString(err) ? err : null);

    if (safeToast) {
      if (message) {
        safeToast.error(translateBackendError(err, message));
      } else {
        safeToast.error("An error occurred!");
      }
      return;
    }

    if (message) {
      console.error("toastError:", message, err);
    } else {
      console.error("toastError: An unknown error occurred", err);
    }
  } catch (e) {
    console.error("toastError handler failure:", e, err);
  }
};

export default toastError;
